module.exports = __webpack_public_path__ + "img/doc.bf6f8a2c.svg";